// Shared-component strings, namespaced as 'components.<componentName>.<key>'.
export default {
  'components.cleanTextContextMenu.copy': '复制纯净文本',
  'components.cleanTextContextMenu.copied': '已复制纯净文本',
  'components.cleanTextContextMenu.failed': '无法复制文本，请重试。',
  'components.addToMattersPopover.selectMattersLabel': '选择项目:',
  'components.addToMattersPopover.searchPlaceholder': '搜索项目...',
  'components.addToMattersPopover.updateSuccess': '项目更新成功',
  'components.addToMattersPopover.updateError': '项目更新失败',
  'components.billingRequiredOverlay.title': '需要处理账单',
  'components.billingRequiredOverlay.manageBillingButton': '管理账单',
  'components.chat.jsonResponseTitle': 'JSON 响应',
  'components.chat.dataOpenedInNewTab': '数据已在新标签页中打开',
  'components.chat.textResponseTitle': '文本响应',
  'components.chat.contentOpenedInNewTab': '内容已在新标签页中打开',
  'components.chat.fileOpenedInNewTab': '文件已在新标签页中打开',
  'components.chat.failedToOpenNewTab': '打开新标签页失败',
  'components.chat.failedToFetchUrl': '获取 URL 失败:{message}',
  'components.chat.referenceDocumentFallback': '参考文档',
  'components.chat.sourcesCount': '来源({count})',
  'components.chat.referencesCount': '{count} 条参考资料',
  'components.chat.htmlContentTitle': 'HTML 内容',
  'components.chat.showMoreLines': '显示更多({count} 行)',
  'components.chatWidget.waitingMessage.justAMoment': '请稍候...',
  'components.chatWidget.waitingMessage.fetchingThatForYou': '正在为您获取相关信息...',
  'components.chatWidget.waitingMessage.hangTight': '请稍等,我正在处理...',
  'components.chatWidget.waitingMessage.letMeCheck': '我来查一下...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond': '马上就好...',
  'components.chatWidget.closeChatAriaLabel': '关闭聊天',
  'components.chatWidget.openChatAriaLabel': '打开聊天',
  'components.chatWidget.processingTooltip': '处理完成后即可使用聊天功能',
  'components.chatWidget.messageCopied': '消息已复制！',
  'components.chatWidget.copyMessageFailed': '消息复制失败',
  'components.chatWidget.header.title': '聊天',
  'components.chatWidget.emptyState.title': '有什么可以帮您的？',
  'components.chatWidget.inputPlaceholder': '输入消息...',
  'components.chatWidget.showMoreLines': '显示更多（{count} 行）',
  'components.chatWidget.invalidFileUrl': '文件链接无效或缺失',
  'components.chatWidget.fileDownloadedSuccessfully': '文件下载成功',
  'components.chatWidget.fileDownloadFailed': '文件下载失败：{message}',
  'components.chatWidget.unnamedFile': '文件',
  'components.chatWidget.attachmentImageAlt': '附件',
  'components.checklistCard.heading': '检查清单',
  'components.downloadLoadingMask.downloading': '下载中...',
  'components.emlViewer.fromLabel': '发件人：',
  'components.emlViewer.toLabel': '收件人：',
  'components.emlViewer.ccLabel': '抄送：',
  'components.emlViewer.dateLabel': '日期：',
  'components.emlViewer.attachmentsLabel': '附件：',
  'components.filesSidePanel.favoritesButton': '收藏夹',
  'components.filesSidePanel.historyButton': '历史记录',
  'components.filesSidePanel.untitledPlaceholder': '（无标题）',
  'components.filesSidePanel.membersPopoverTitle': '成员',
  'components.filesSidePanel.ownerTag': '所有者',
  'components.filesSidePanel.modifyGroupTooltip': '修改群组',
  'components.filesSidePanel.privateGroupWarningTooltip': '安全性较低：您的群组可见。',
  'components.filesSidePanel.firmWideWarningTooltip': '安全性极低：您所在律所可见。',
  'components.filesSidePanel.publicWarningTooltip': '安全性极低：所有人可见。',
  'components.filesSidePanel.sortByDateLabel': '按日期排序（从新到旧）',
  'components.filesSidePanel.sortAlphabeticallyLabel': '按字母顺序排序（A-Z）',
  'components.gettingStartedTour.insiderHero.openLinkLabel': '打开 A&GEL Insider',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle': '学习新工具需要时间',
  'components.gettingStartedTour.insiderHero.basicsCard.copy': '从第一天起您所需的一切。',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': '从基础开始',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': '了解更多',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy': '近期上线与更新内容。',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': '新功能',
  'components.gettingStartedTour.insiderHero.marinaAlt': '海港天际线',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': '精选文章',
  'components.gettingStartedTour.insiderHero.filesUpload.title': '文件上传',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': '查看更多',
  'components.gettingStartedTour.allCompleted.title': '您已完成 A&GEL 完整导览！',
  'components.gettingStartedTour.allCompleted.redoButton': '重新导览',
  'components.gettingStartedTour.heading': '新手入门',
  'components.gettingStartedTour.tourStyles.stepIndicator': '第 {current} 步，共 {total} 步',
  'components.gettingStartedTour.tourStyles.nextDefault': '下一步 →',
  'components.gettingStartedTour.chatTour.step2.title': '这是您已加载的文档。',
  'components.gettingStartedTour.chatTour.step2.nextLabel': '关闭并继续 →',
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay': '本协议中的保密义务是什么？',
  'components.gettingStartedTour.chatTour.step4.text': '引用会链接到 AI 所使用的文档具体位置。',
  'components.gettingStartedTour.chatTour.completeModal.title': '做得好！',
  'components.gettingStartedTour.tourComplete.completeButton': '完成',
  'components.gettingStartedTour.tourComplete.continueButton': '继续前往 {title} →',
  'components.gettingStartedTour.playbookTour.completeModal.title': '干得好！',
  'components.gettingStartedTour.playbookTour.step1.openingLabel': '正在打开…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': '打开示例 →',
  'components.gettingStartedTour.playbookTour.step2.title': '我们已起草了 3 项修订请求：',
  'components.gettingStartedTour.playbookTour.step2.item1': '• 知识产权共有（第 17 条）',
  'components.gettingStartedTour.playbookTour.step2.item2': '• 增加 14 天补救期（第 8 条）',
  'components.gettingStartedTour.playbookTour.step2.item3': '• 缩小竞业限制范围（第 27 条）',
  'components.gettingStartedTour.playbookTour.step3.title': '点击“发送”以生成修订。',
  'components.gettingStartedTour.playbookTour.step4.text': '每张卡片都显示原文及建议的修改内容。',
  'components.gettingStartedTour.playbookTour.step5.title': '查看此项修订并选择接受或拒绝。',
  'components.gettingStartedTour.playbookTour.step5.text': '您之后可以对其余部分重复此操作。',
  'components.gettingStartedTour.reviewTour.completeModal.title': '太棒了！',
  'components.gettingStartedTour.reviewTour.step2.title': '按类别浏览预置的问题清单。',
  'components.gettingStartedTour.reviewTour.step4.title': '选择一个类别来组织您的清单。',
  'components.gettingStartedTour.reviewTour.step9.title': '保存您的清单，以便在文档中使用。',
  'components.gettingStartedTour.reviewTour.step10.title': '我们已为您加载了一些示例文档以供体验。',
  'components.gettingStartedTour.reviewTour.step11.title': '点击“提交”以对所有文档运行审阅。',
  'components.gettingStartedTour.reviewTour.step13.title': '点击任意答案，即可查看其确切来源。',
  'components.gettingStartedTour.reviewTour.step15.nextLabel': '完成',
  'components.gettingStartedTour.scribeTour.completeModal.title': '干得好！',
  'components.gettingStartedTour.scribeTour.step1.title': '选择您将用此转录内容做什么。',
  'components.gettingStartedTour.scribeTour.step2.title': '语言已设置为“自动检测”。',
  'components.gettingStartedTour.scribeTour.step3.title': '点击录音按钮，或上传已有的音频文件。',
  'components.gettingStartedTour.scribeTour.step4.title': '准备保存转录内容时，点击“停止”。',
  'components.gettingStartedTour.scribeTour.step7.title': '点击“编辑”以修改转录内容。',
  'components.gettingStartedTour.scribeTour.step7.text': '您的修改将以金色显示。',
  'components.gettingStartedTour.scribeTour.step8.title': '点击“保存”以保留您的修改。',
  'components.gettingStartedTour.scribeTour.step8.text': '保存前，您的修改会以金色显示。',
  'components.gettingStartedTour.searchTour.completeModal.title': '做得好！',
  'components.gettingStartedTour.searchTour.step1.title': '我们已为您准备了一个搜索查询。',
  'components.gettingStartedTour.searchTour.step1.text': '点击“搜索”或按回车键以查找匹配的条款。',
  'components.gettingStartedTour.tourButton.label': '导览',
  'components.gettingStartedTour.tourCompleteModal.features.chat': '在聊天中提问',
  'components.gettingStartedTour.tourCompleteModal.features.search': '跨文档搜索',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': '使用 Scribe 转录',
  'components.gettingStartedTour.tourCompleteModal.features.review': '使用审阅功能进行分析',
  'components.gettingStartedTour.tourCompleteModal.features.playbook': '在 Workstudio 中应用修订',
  'components.gettingStartedTour.tourCompleteModal.title': '一切就绪！',
  'components.gettingStartedTour.tourCompleteModal.subtitle': '您已完成 A&GEL 导览，并学会了如何：',
  'components.gettingStartedTour.tourCompleteModal.progressText': '已完成 5 项功能中的全部 5 项',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': '开始使用 A&GEL →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix': '需要帮助？请访问',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': '用户指南',
  'components.lLMMetrics.status.fast': '快速',
  'components.lLMMetrics.status.slow': '缓慢',
  'components.lLMMetrics.status.busy': '繁忙',
  'components.lLMMetrics.status.pending': '待处理',
  'components.lLMMetrics.status.loading': '加载中',
  'components.lLMMetrics.metricBox.defaultChartLabel': '数值',
  'components.management.passwordModal.usernameColumn': '用户名',
  'components.management.passwordModal.passwordColumn': '密码',
  'components.management.passwordModal.createHeader': '您已成功创建用户，凭证如下：',
  'components.management.passwordModal.emailChangeHeader': '您已成功更改用户邮箱。新凭证如下：',
  'components.management.passwordModal.changePasswordNotice': '*用户首次登录后必须修改密码',
  'components.menuPanel.untitledItem': '（无标题）',
  'components.menuPanel.renameFailed': '重命名失败',
  'components.menuPanel.deleteConfirm.title': '删除历史记录项',
  'components.menuPanel.deleteConfirm.content': '确定要删除此历史记录项吗？此操作无法撤销。',
  'components.menuPanel.deleteConfirm.createdLabel': '创建时间：',
  'components.menuPanel.deleteSuccess': '历史记录项删除成功',
  'components.menuPanel.deleteFailed': '删除历史记录项失败',
  'components.menuPanel.searchHistoryButton': '搜索历史记录',
  'components.menuPanel.historyLabel': '历史记录',
  'components.menuPanel.showAllButton': '显示全部',
  'components.menuPanel.showFavoritesButton': '显示收藏',
  'components.menuPanel.endOfListMessage': '- 到底了 -',
  'components.message.enhanceGpt.modalTitle': '优化 GPT 回复',
  'components.message.enhanceGpt.successMessage': '新回复已记录',
  'components.message.enhanceGpt.questionLabel': '问题：{question}',
  'components.message.enhanceGpt.answerLabel': '答案',
  'components.message.postback.clickedLabel': '已点击：',
  'components.message.postback.chatbotButtonFallback': '聊天机器人按钮',
  'components.message.locationLabel': '位置',
  'components.message.stickerLabel': '贴纸',
  'components.message.audiosLabel': '音频',
  'components.message.imagesLabel': '图片',
  'components.message.videosLabel': '视频',
  'components.msgViewer.fromLabel': '发件人：',
  'components.msgViewer.toLabel': '收件人：',
  'components.msgViewer.attachmentsLabel': '附件：',
  'components.pdfViewerWithHighlight.renderError': 'PDF 渲染失败',
  'components.promptSelector.copySuccess': '提示词已复制！',
  'components.promptSelector.copyError': '复制提示词失败',
  'components.promptSelector.noResultsFiltered': '未找到符合筛选条件的提示词',
  'components.promptSelector.startTyping': '输入以搜索提示词',
  'components.promptSelector.promptLoaded': '提示词已加载！',
  'components.promptSelector.untitledPrompt': '未命名提示词',
  'components.promptSelector.actionPlaceholder': '操作',
  'components.promptSelector.actionOption.summarise': '摘要',
  'components.promptSelector.actionOption.review': '审阅',
  'components.promptSelector.actionOption.amend': '修订',
  'components.promptSelector.actionOption.draft': '起草',
  'components.promptSelector.actionOption.redFlagging': '风险标记',
  'components.promptSelector.audiencePlaceholder': '受众',
  'components.promptSelector.audienceOption.personal': '个人',
  'components.promptSelector.audienceOption.group': '群组',
  'components.promptSelector.audienceOption.public': '公开',
  'components.promptSelector.selectPromptHint': '选择一个提示词以将其加载到输入框',
  'components.promptSelector.usePromptButton': '使用提示词',
  'components.promptSelector.authorLabel': '作者',
  'components.promptSelector.promptLabel': '提示词',
  'components.promptSelector.tagsLabel': '标签',
  'components.promptSelector.documentsAttached': '将附加 {count} 份文档',
  'components.questionListSelection.untitledQuestionList': '（未命名）',
  'components.questionListSelection.questionCount': '{count} 个问题',
  'components.questionListSelection.accessPublicTag': '公开',
  'components.questionListSelection.accessFirmTag': '律所',
  'components.questionListSelection.accessGroupTag': '私密小组',
  'components.questionListSelection.viewLess': '收起',
  'components.questionListSelection.viewAll': '查看全部',
  'components.questionListSelection.whatsNewButton': '新功能',
  'components.questionListSelection.tourTooltip': '开始导览',
  'components.questionListSelection.tourButton': '导览',
  'components.questionListSelection.sortMostPopular': '排序：最受欢迎',
  'components.questionListSelection.sortNameAsc': '排序：名称 A-Z',
  'components.questionListSelection.sortNameDesc': '排序：名称 Z-A',
  'components.questionListSelection.filterByAudiencePlaceholder': '按受众筛选',
  'components.questionListSelection.audienceOptionPersonal': '个人',
  'components.questionListSelection.audienceOptionPublic': '公开',
  'components.questionListSelection.filterByAuthorPlaceholder': '按作者筛选',
  'components.reference.unknownAuthor': '未知',
  'components.reference.timeAgo.justNow': '刚刚',
  'components.reference.timeAgo.minutesAgo': '{count} 分钟前',
  'components.reference.timeAgo.hoursAgo': '{count} 小时前',
  'components.reference.timeAgo.daysAgo': '{count} 天前',
  'components.reference.openCellDetails': '打开单元格详情',
  'components.reference.answerLabel': '答案：',
  'components.reference.explanationLabel': '解释说明',
  'components.reference.verifiedLabel': '已核实',
  'components.reference.verifyLabel': '核实',
  'components.reference.pleaseEnterComment': '请输入评论内容',
  'components.reference.commentAddedSuccess': '评论添加成功',
  'components.reference.failedToAddComment': '添加评论失败',
  'components.reference.commentUpdatedSuccess': '评论更新成功',
  'components.reference.updateOwnCommentsOnly': '您只能更新自己的评论',
  'components.reference.failedToUpdateComment': '更新评论失败',
  'components.reference.commentDeletedSuccess': '评论删除成功',
  'components.reference.deleteOwnCommentsOnly': '您只能删除自己的评论',
  'components.reference.failedToDeleteComment': '删除评论失败',
  'components.reference.deleteComment.title': '删除评论',
  'components.reference.deleteComment.description': '确定要删除此评论吗？',
  'components.reference.addCommentPlaceholder': '添加评论……',
  'components.reference.cellsSelected': '已选择 {count} 个单元格。',
  'components.reference.selectCellAriaLabel': '选择单元格',
  'components.reference.selectQuestionRowAriaLabel': '选择问题行',
  'components.reference.selectDocumentColumnAriaLabel': '选择文档列',
  'components.reference.selectDocumentRowAriaLabel': '选择文档行',
  'components.reference.selectQuestionColumnAriaLabel': '选择问题列',
  'components.reference.documentsHeader': '文档',
  'components.reference.addRow': '添加行',
  'components.reference.addColumn': '添加列',
  'components.reference.inverse': '反转',
  'components.reference.showAllColumns': '显示所有列',
  'components.reference.showAllRows': '显示所有行',
  'components.reference.resetView': '重置视图',
  'components.reference.summaryView': '摘要视图',
  'components.reference.exactQuote': '原文引用',
  'components.reference.exactQuoteView': '原文引用视图',
  'components.reference.detailedView': '详细视图',
  'components.reference.exitSelectMode': '退出',
  'components.reference.chatWithSelectedOutput': '与所选输出对话',
  'components.reference.selectCells': '选择单元格',
  'components.referencePopover.fileLinkUnavailable': '文件链接不可用',
  'components.referencePopover.failedToOpenNewTab': '打开新标签页失败',
  'components.referencePopover.failedToOpenFile': '打开文件失败',
  'components.referencePopover.openInNewTab': '在新标签页中打开文档 ↗',
  'components.rightContent.organisationSwitcher.switching': '正在切换组织……',
  'components.rightContent.organisationSwitcher.switchSuccess': '组织切换成功',
  'components.rightContent.organisationSwitcher.switchNoToken': '切换组织未返回新令牌',
  'components.rightContent.organisationSwitcher.switchError': '切换组织失败',
  'components.rightContent.organisationSwitcher.unknownOrg': '未知组织',
  'components.rightContent.organisationSwitcher.defaultLabel': '组织',
  'components.rightContent.organisationSwitcher.tooltipFallback': '切换组织',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.rightContent.angelTeamsButton.label': '联系我们',
  'components.rightContent.reportBug.label': '报告问题',
  'components.rightContent.reportBug.modalDescription': '请填写以下表单，告诉我们您遇到的问题。',
  'components.rightContent.reportBug.contactSectionTitle': '联系方式',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': '问题描述',
  'components.rightContent.reportBug.environmentSectionTitle': '环境信息',
  'components.rightContent.reportBug.namePlaceholder': '请输入您的姓名',
  'components.rightContent.reportBug.nameRequired': '请输入您的姓名',
  'components.rightContent.reportBug.emailLabel': '电子邮箱',
  'components.rightContent.reportBug.emailPlaceholder': '请输入您的电子邮箱',
  'components.rightContent.reportBug.emailRequired': '请输入您的电子邮箱',
  'components.rightContent.reportBug.emailInvalid': '请输入有效的电子邮箱',
  'components.rightContent.reportBug.locationLabel': '问题出现在哪里？',
  'components.rightContent.reportBug.locationPlaceholder': '选择功能模块',
  'components.rightContent.reportBug.locationRequired': '请说明问题出现的位置',
  'components.rightContent.reportBug.descriptionLabel': '描述问题',
  'components.rightContent.reportBug.descriptionRequired': '请描述该问题',
  'components.rightContent.reportBug.filesLabel': '截图或录屏',
  'components.rightContent.reportBug.uploadText': '点击或拖拽以上传',
  'components.rightContent.reportBug.fileSizeKb': '{size} KB',
  'components.rightContent.reportBug.removeFile': '移除 {fileName}',
  'components.rightContent.reportBug.deviceLabel': '设备',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': '请说明您使用的设备',
  'components.rightContent.reportBug.osLabel': '操作系统及版本',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': '请说明您的操作系统',
  'components.rightContent.reportBug.browserLabel': '浏览器',
  'components.rightContent.reportBug.browserPlaceholder': '选择浏览器',
  'components.rightContent.reportBug.browserRequired': '请说明您使用的浏览器',
  'components.rightContent.reportBug.submitSuccess': '问题反馈提交成功！',
  'components.rightContent.reportBug.submitError': '提交问题反馈失败，请重试。',
  'components.rightContent.reportBug.invalidFileType': '只能上传图片或视频文件！',
  'components.rightContent.reportBug.fileUploadSuccess': '文件 "{fileName}" 上传成功！',
  'components.rightContent.reportBug.fileUploadError': '文件上传失败',
  'components.rightContent.reportBug.page.home': '首页',
  'components.rightContent.reportBug.page.chat': '聊天',
  'components.rightContent.reportBug.page.composer': '撰写器',
  'components.rightContent.reportBug.page.review': '审阅',
  'components.rightContent.reportBug.page.reference': '参考资料',
  'components.rightContent.reportBug.page.files': '文件',
  'components.rightContent.reportBug.page.userProfile': '用户资料',
  'components.rightContent.reportBug.page.other': '其他',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.other': '其他',
  'components.rightContent.receiptModal.title': '感谢您',
  'components.rightContent.receiptModal.description': '您的报告已提交。',
  'components.scribe.clickToStartRecording': '点击开始录音',
  'components.scribe.failedToGetAuthToken': '获取身份验证令牌失败',
  'components.scribe.failedToStartRecording': '启动录音失败',
  'components.searchPdfViewerWithHighlight.renderError': 'PDF 渲染失败',
  'components.themeToggle.themeSectionLabel': '主题',
  'components.themeToggle.themeTeal': '🌊 青色',
  'components.themeToggle.themeMaroon': '🍷 酒红色',
  'components.themeToggle.modeSectionLabel': '模式',
  'components.themeToggle.lightMode': '浅色',
  'components.themeToggle.darkMode': '深色',
  'components.themeToggle.themeSettingsTooltip': '主题设置',
  'components.billingRequiredOverlay.defaultMessage':
    '您的组织账单需要处理后才能继续此操作,请联系您的组织管理员。',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    '如果您想更进一步，还有强大的功能等着您。',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    '将完整的电子邮件文件（包括附件）上传至 A&GEL，并像处理其他文档一样处理它们。',
  'components.gettingStartedTour.chatTour.step1.title':
    '我们已为您加载了一份 NDA 示例。点击“上下文”即可查看。',
  'components.gettingStartedTour.chatTour.step1.text':
    '在这里，您可以管理 A&GEL 回答问题时参考的文档。',
  'components.gettingStartedTour.chatTour.step2.text':
    '您可以上传文件或从“文件库”中选择。准备就绪后关闭面板即可。',
  'components.gettingStartedTour.chatTour.step3.title':
    '我们已为您准备了一个问题。点击“发送”即可询问该 NDA 相关内容。',
  'components.gettingStartedTour.chatTour.step4.title':
    '回答得很好！现在点击引用编号（如 [1]）即可查看来源文档。',
  'components.gettingStartedTour.chatTour.completeModal.description':
    '您在聊天中提出了第一个问题，并获得了带引用的答案。',
  'components.gettingStartedTour.tourComplete.progressText':
    '已完成 5 项功能中的 {completedCount} 项',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    '您已使用 Workstudio 应用了修订。',
  'components.gettingStartedTour.playbookTour.step1.title':
    '我们已为您加载了一份需要修订的供应商协议示例。',
  'components.gettingStartedTour.playbookTour.step1.text':
    '您是供应商（Pand.ai），正在向客户请求更优惠的条款。',
  'components.gettingStartedTour.playbookTour.step2.text':
    '多步骤模式会并行处理每一项，以更快获得结果。',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL 将显示修订痕迹，您可以接受、拒绝或下载。',
  'components.gettingStartedTour.playbookTour.step4.title':
    '以下是 A&GEL 根据您的提示起草的修订内容。',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    '您创建了一份问题清单，并用它审阅了文档。',
  'components.gettingStartedTour.reviewTour.step1.title':
    '“审阅”功能使用问题清单在多份文档中回答您的问题。',
  'components.gettingStartedTour.reviewTour.step1.text':
    '您可以创建自己的清单，也可以使用现有的清单。',
  'components.gettingStartedTour.reviewTour.step3.title':
    '让我们创建您自己的清单。点击此处新建问题清单。',
  'components.gettingStartedTour.reviewTour.step5.title':
    '以下是一些示例问题，已作为可编辑行添加到您的清单中。',
  'components.gettingStartedTour.reviewTour.step6.title':
    '您的问题会以可编辑行的形式显示在此处。您可以随时删除，或添加分组以对其归类。',
  'components.gettingStartedTour.reviewTour.step7.title':
    '描述此清单的用途——根据您的需求进行定制。',
  'components.gettingStartedTour.reviewTour.step8.title':
    '调整 AI 回答的方式——语气、格式和详细程度。',
  'components.gettingStartedTour.reviewTour.step10.text':
    '您的问题清单已准备就绪，可以对这些文档运行。',
  'components.gettingStartedTour.reviewTour.step12.title':
    '每一行代表一个问题，每一列代表一份文档。答案将自动提取。',
  'components.gettingStartedTour.reviewTour.step14.title':
    '点击引用编号，即可跳转到源文档中的确切段落。',
  'components.gettingStartedTour.reviewTour.step15.title':
    '这就是完整的审阅流程——来源始终触手可及。您已完成全部内容！',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    '您已使用 Scribe 转录了音频。',
  'components.gettingStartedTour.scribeTour.step1.text':
    '这有助于 A&GEL 设置输出格式。系统已默认选择“会议记录”。',
  'components.gettingStartedTour.scribeTour.step2.text':
    '您也可以启用实时翻译，以实时查看翻译内容。',
  'components.gettingStartedTour.scribeTour.step5.title':
    '为您的转录内容输入名称，然后点击“保存”。',
  'components.gettingStartedTour.scribeTour.step6.title':
    '点击任意一行转录内容，即可从该处播放音频。',
  'components.gettingStartedTour.searchTour.completeModal.description':
    '您已在多份文档中进行搜索，并找到了相关条款。',
  'components.gettingStartedTour.searchTour.step2.title':
    '这是来自 NDA 的一个匹配结果。点击文档即可查看其中的所有匹配项。',
  'components.gettingStartedTour.searchTour.step3.title':
    '点击任意片段即可跳转到文档中的相应部分。',
  'components.gettingStartedTour.searchTour.step3.text':
    '左侧显示匹配的摘录，右侧是标注关键词高亮的完整文档。',
  'components.reference.matrixIdRequired':
    '需要提供 Matrix ID。请确保已将 matrixId 属性传递给 Reference 组件。',
  'components.whatsNewModal.title': '新功能',
  'components.whatsNewModal.intro': '我们推出了多项新功能，以提升您的文档审阅体验：',
  'components.whatsNewModal.feature1.title': '筛选功能优化：',
  'components.whatsNewModal.feature1.description': '新增受众和作者筛选器，帮助您更快找到问题列表。',
  'components.whatsNewModal.feature2.title': '临时问题：',
  'components.whatsNewModal.feature2.description': '更灵活的方式，可随时添加问题。',
  'components.whatsNewModal.feature3.title': '界面优化：',
  'components.whatsNewModal.feature3.description':
    '更简洁、更直观的界面，便于管理您的{featureName}。',
  'components.whatsNewModal.upcomingFeatures.title': '即将推出的功能',
  'components.whatsNewModal.upcomingFeatures.description':
    '敬请期待更多更新，包括协作审阅和高级 AI 分析功能。',
  'components.user.uidLabel': 'UID',
  'components.user.idCopiedMessage': 'ID 已复制！',
  'components.file.manager.fetchGroupError': '获取分组失败：{message}',
  'components.file.manager.fetchFilesError': '获取文件失败：{message}',
  'components.file.manager.breadcrumbRoot': '根目录',
  'components.file.manager.breadcrumbBackUpLevel': '返回上一级',
  'components.file.manager.searchPlaceholder': '搜索文件或文件夹',
  'components.file.manager.uploadFileButton': '上传文件',
  'components.file.manager.createFolderButton': '新建文件夹',
  'components.file.manager.enterButton': '进入',
  'components.file.manager.deleteFolderButton': '删除文件夹',
  'components.file.manager.deleteFileButton': '删除文件',
  'components.file.manager.uploadedByTime': '上传者：{username}，上传时间：{createdAt}',
  'components.file.manager.folderNamePlaceholder': '文件夹名称',
  'components.file.filePreview.cannotPreview': '该文件类型不支持预览',
  'components.file.documentSelector.sortNameAsc': '名称（A-Z）',
  'components.file.documentSelector.sortNameDesc': '名称（Z-A）',
  'components.file.documentSelector.sortNewestFirst': '最新优先',
  'components.file.documentSelector.sortOldestFirst': '最早优先',
  'components.file.documentSelector.favourites': '收藏夹',
  'components.file.documentSelector.selectedCount': '已选择（{count}）：',
  'components.file.documentSelector.selectAllFilesInFolder': '选择 {folderName} 中的所有文件',
  'components.file.documentSelector.noFiles': '暂无文件',
  'components.file.documentSelector.folderAlt': '文件夹',
  'components.file.documentSelector.fileAlt': '文件',
  'components.file.documentSelector.selectDocuments': '选择文档',
  'components.file.documentSelector.selectOkText': '选择',
  'components.file.fileTree.uploadFailed': '{fileName} 上传失败',
  'components.file.fileTree.clickOrDragToUpload': '点击或拖拽上传',
  'components.file.fileTree.noFilesUploadedOrSelected': '尚未上传或选择任何文件。',
  'components.file.selectContext.cannotDeleteDefaultContext':
    '无法删除默认上下文。请先将其他上下文设为默认。',
  'components.file.selectContext.contextDeleted': '上下文已删除',
  'components.file.selectContext.deleteContextFailed': '删除上下文失败',
  'components.file.selectContext.enterContextNameWarning': '请输入上下文名称',
  'components.file.selectContext.contextCreated': '上下文已创建',
  'components.file.selectContext.cannotUnsetDefaultContext':
    '无法取消默认上下文。请先将其他上下文设为默认。',
  'components.file.selectContext.contextUpdated': '上下文已更新',
  'components.file.selectContext.createContextFailed': '创建上下文失败',
  'components.file.selectContext.updateContextFailed': '更新上下文失败',
  'components.file.selectContext.selectContextPresetPlaceholder': '选择上下文预设',
  'components.file.selectContext.defaultLabel': '（默认）',
  'components.file.selectContext.deleteContextConfirmTitle': '确定要删除此上下文吗？',
  'components.file.selectContext.deleteContextConfirmDescription': '此操作无法撤销。',
  'components.file.selectContext.addNewContextTooltip': '添加新上下文',
  'components.file.selectContext.modifyContextInfoTooltip': '修改上下文信息',
  'components.file.selectContext.newContextLabel': '新建上下文',
  'components.file.selectContext.editContextLabel': '编辑上下文',
  'components.file.selectContext.contextTitlePlaceholder': '上下文标题',
  'components.file.selectContext.setAsDefaultLabel': '设为默认',
  'components.file.selectContext.contextSelectionTitle': '上下文选择',
  'components.file.selectContext.noContextSelected': '未选择上下文',
  'components.appShell.logoutMenuItem': '退出登录',
  'components.appShell.unauthorized.title': '此页面不适合您访问',
  'components.appShell.unauthorized.backHome': '返回首页',
  'components.appShell.promptLibrary.title': '提示词库',
  'components.appShell.promptLibrary.noPromptsAvailable': '暂无可用提示词',
  'components.appShell.promptLibrary.copyTooltip': '复制提示词内容',
  'components.appShell.promptLibrary.untitledPrompt': '未命名提示词',
  'components.appShell.promptLibrary.copiedMessage': '提示词已复制到剪贴板！',
  'components.appShell.clipboard.title': '剪贴板',
  'components.appShell.clipboard.copiedMessage': '已复制！',
  'components.appShell.notFound.title': '此页面不存在',
  'components.gettingStartedTour.tourTask.chat.title': '聊天',
  'components.gettingStartedTour.tourTask.chat.duration': '~1 分钟',
  'components.gettingStartedTour.tourTask.search.title': '搜索',
  'components.gettingStartedTour.tourTask.search.duration': '~1 分钟',
  'components.gettingStartedTour.tourTask.scribe.title': '录音',
  'components.gettingStartedTour.tourTask.scribe.duration': '~2 分钟',
  'components.gettingStartedTour.tourTask.review.title': '审查',
  'components.gettingStartedTour.tourTask.review.duration': '~3 分钟',
  'components.gettingStartedTour.tourTask.playbook.title': 'Workstudio',
  'components.gettingStartedTour.tourTask.playbook.duration': '~2 分钟',
  'components.matrixPolling.processingStoppedMessage': '处理已停止',
  'components.matrixPolling.stopProcessingFailedMessage': '停止处理失败',
  'components.appShell.noResponseError': '无响应！请重试。',
  'components.appShell.requestError': '请求错误，请重试。',
  'components.appShell.requestFailedError': '请求失败！',
  'components.composerService.socketErrorPrefix': '错误：{message}',
  'components.composerService.sessionDisconnected': 'Composer 会话因另一个连接而断开',
  'components.fileViewerWithToken.retrieveFailedError': '获取文件失败',
  'components.languageSwitcher.switchLanguageTooltip': '切换语言',
  'components.crossOrgBadge.sharedByLabel': '共享者：{orgName}',
  'components.crossOrgBadge.externalOrganization': '外部机构',
  'components.file.sharePoint.fromComputer': '从此电脑',
  'components.file.sharePoint.fromSharePoint': '从 SharePoint / OneDrive',
  'components.file.sharePoint.orAddFromSharePoint': '或从 SharePoint / OneDrive 添加',
  'components.file.sharePoint.account': 'Microsoft 账户',
  'components.file.sharePoint.useDifferentAccount': '使用其他账户',
  'components.file.sharePoint.disconnect': '断开连接',
  'components.file.sharePoint.disconnectConfirm': '要从 A&GEL 断开您的 Microsoft 账户吗？',
  'components.file.sharePoint.disconnected': '已断开 Microsoft 账户。',
  'components.file.sharePoint.popupBlocked': '请允许 A&GEL 弹出窗口，以便从 SharePoint 选择文件。',
  'components.file.sharePoint.consentDeniedTitle': 'SharePoint 访问未获批准',
  'components.file.sharePoint.consentDenied':
    'SharePoint 访问未获批准。如果您的组织需要 IT 管理员审批，请联系 IT 管理员批准 A&GEL。',
  'components.file.sharePoint.copyApprovalLink': '复制审批链接给 IT 管理员',
  'components.file.sharePoint.approvalLinkCopied': '审批链接已复制。',
  'components.file.sharePoint.connectFailed': '无法连接到 Microsoft，请重试。',
  'components.file.sharePoint.reconnect': '请重新连接您的 Microsoft 账户。',
  'components.file.sharePoint.unsupportedType': '此处不支持 {name} 的文件类型。',
  'components.file.sharePoint.tooLarge': '{name} 太大（最大 {max} MB）。',
  'components.file.sharePoint.rejected': '无法添加 {name}。',
  'components.file.sharePoint.downloadFailed':
    '无法从 SharePoint 获取 {name}。请重试，或从电脑上传。',
  'components.file.sharePoint.folderTooLarge':
    '此文件夹太大，无法一次导入（最多 {max} 个文件）。请选择较小的文件夹。',
  'components.file.sharePoint.chooserTitle': '选取文件',
  'components.file.sharePoint.chooserMyFiles': '我的文件',
  'components.file.sharePoint.chooserShared': '共享',
  'components.file.sharePoint.chooserFollowedSites': '已关注的网站',
  'components.file.sharePoint.chooserSearch': '搜索网站',
  'components.file.sharePoint.chooserName': '名称',
  'components.file.sharePoint.chooserEmpty': '您尚未关注任何网站。请在上方搜索网站。',
  'components.file.sharePoint.chooserLocked':
    '仅显示您关注或搜索到的网站。如需浏览所有网站，请让 IT 管理员批准 A&GEL。',
  'components.file.sharePoint.chooserLoading': '加载中…',
  'components.file.sharePoint.chooserSelect': '选择',
  'components.file.sharePoint.chooserCancel': '取消',
};
